"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoansModalManager = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var useCurrency_1 = require("../hooks/useCurrency");
var loan_details_modal_1 = require("./loan-details-modal");
var my_loans_1 = require("./my-loans");
var LoansModalManager = function (_a) {
    var branding = _a.branding, siteName = _a.siteName, siteConfig = _a.siteConfig;
    var currency = (0, useCurrency_1.useCurrency)(siteConfig).currency;
    var _b = (0, react_1.useState)("list"), activeModal = _b[0], setActiveModal = _b[1];
    var _c = (0, react_1.useState)(null), selectedLoan = _c[0], setSelectedLoan = _c[1];
    var handleViewLoan = function (loan) {
        setSelectedLoan(loan);
        setActiveModal("details");
    };
    var handleBackToList = function () {
        setSelectedLoan(null);
        setActiveModal("list");
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [activeModal === "list" && ((0, jsx_runtime_1.jsx)(my_loans_1.MyLoans, { branding: branding, siteName: siteName, siteConfig: siteConfig, onViewLoan: handleViewLoan })), activeModal === "details" && selectedLoan && ((0, jsx_runtime_1.jsx)(loan_details_modal_1.LoanDetailsModal, { isOpen: true, onClose: handleBackToList, loan: selectedLoan, branding: branding, currency: currency }))] }));
};
exports.LoansModalManager = LoansModalManager;
